import { create } from "zustand"
import { devtools } from "zustand/middleware"

type DialogStore = {
  lastOpenedDialogId: string | null
  setLastOpenedDialogId: (id: string | null) => void
}

export const createDialogStore = create<DialogStore>()(
  devtools(
    (set) => ({
      lastOpenedDialogId: null,
      setLastOpenedDialogId: (id) => set({ lastOpenedDialogId: id }),
    }),
    {
      store: "dialog",
      enabled: process.env.NODE_ENV !== "production",
    },
  ),
)
